import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Placeholder from '../../common/CustomPlaceholder'
import PairingGroup from './PairingGroup'

import { ReactComponent as Calendar } from '../../../assets/images/common/icons/circle-calendar.svg'
import colors from '../../../assets/styles/globals.scss'
import styles from './PairingsPage.module.scss'
import classNames from 'classnames'

const PairingsPage = ({ event }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  if (event.status === 'draft') {
    return (
      <Placeholder
        title={t('events.detail.pairingsPage.pairingsNotAvailableTitle')}
        icon={<Calendar fill={colors.placeholderGray} width={100} height={100} className='mb-3'/>}
        subtext={t('events.detail.pairingsPage.draftStateSubtext')}
      />
    )
  }
  return (
    <div className={classNames(styles.pairingsPage, 'd-flex flex-column table-container')}>
      {event.pairings.pairingGroups.length ?
        <div className={styles.pairingGroups}>
          {event.pairings.status === 'draft' &&
            <div className={styles.draftPairingsMessage}>
              <i className='fa fa-exclamation-triangle' />
              <span className='ml-3'>{t('events.detail.pairingsPage.draftPairingsWarning')}</span>
            </div>
          }
          {event.pairings.pairingGroups.map((pairingGroup, index) => (
            <PairingGroup key={index} pairingGroup={pairingGroup} format={event.pairings.format}/>
          ))}
        </div>
        :
        <Placeholder
          title={t('events.detail.pairingsPage.noPairingsCreatedTitle')}
          icon={<Calendar fill={colors.placeholderGray} width={100} height={100} className='mb-3'/>}
          subtext={t('events.detail.pairingsPage.noPairingsSubtext')}
          handleAction={() => navigate(`/events/${event.id}/manage-pairings`)}
          buttonText={t('events.common.createPairings')}
        />
      }
    </div>
  )
}

PairingsPage.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
    pairings: PropTypes.shape({
      status: PropTypes.string,
      pairingGroups: PropTypes.array,
      format: PropTypes.string,
    }),
    status: PropTypes.string,
  }),
}

export default PairingsPage
